import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// hero-4.twig
import React from 'react';
import { Section, Box, Video, Container } from '@miro-site/core';
import { contextualSpaces, Headline, Content, LazyImageAdapter, ButtonAdapter } from '@miro-site/components_utils';
import { theme } from '@miro-site/design-tokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BACKGROUNDS = {
  dark: theme.colors.primaryIndigo,
  blue: theme.colors.lightBlue,
  pink: theme.colors.lightPink,
  yellow: theme.colors.lightYellow,
  transparent: 'transparent'
};
var ImageNormalStyles = {
  height: 'auto',
  display: 'block',
  margin: '0 auto',
  overflow: 'hidden',
  width: [437, 930],
  maxWidth: ['100%', null],
  borderRadius: [4, 8],
  paddingLeft: [20, null, null, null],
  paddingRight: [20, null, null, null]
};
var VideoNormalStyles = {
  height: 'auto',
  display: 'block',
  margin: '0 auto',
  overflow: 'hidden',
  width: [325, 930],
  borderRadius: [4, 8]
};

var VideoBigStyles = _objectSpread(_objectSpread({}, VideoNormalStyles), {}, {
  width: [325, 1120]
});

var ImageBigStyles = _objectSpread(_objectSpread({}, ImageNormalStyles), {}, {
  width: [437, 1120]
});

var Hero = function Hero(_ref) {
  var background = _ref.background,
      headline = _ref.headline,
      content = _ref.content,
      button = _ref.button,
      additional_button = _ref.additional_button,
      image = _ref.image,
      tooltip = _ref.tooltip,
      video = _ref.video;
  var isDarkMode = background == 'dark';

  var getAdditionalButtonType = function getAdditionalButtonType() {
    if (additional_button !== null && additional_button !== void 0 && additional_button.type) return additional_button.type;
    return background ? 'white' : 'transparent';
  };

  return /*#__PURE__*/_jsx(Section, {
    "data-place": "Hero Section",
    type: "large",
    $styles: {
      backgroundColor: background ? BACKGROUNDS[background] : null,
      textAlign: 'center'
    },
    children: /*#__PURE__*/_jsxs(Container, {
      children: [(headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
        color: isDarkMode ? 'white' : headline.color,
        size: "medium",
        tag: "h1",
        align: headline.align || 'center'
      })), content && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, content), {}, {
        textProps: {
          $mx: 'auto',
          $styles: {
            maxWidth: [null, 550],
            marginTop: contextualSpaces.textSpaces.afterHeadline.medium
          }
        },
        color: isDarkMode ? 'white' : content.color,
        colorTransparency: isDarkMode ? 0.4 : null
      })), (button || additional_button) && /*#__PURE__*/_jsxs(Box, {
        $styles: {
          marginTop: contextualSpaces.buttonSpaces.afterText.common
        },
        children: [button && /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread({}, button)), additional_button && /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({
          $styles: {
            marginLeft: [null, theme.spaces.sm],
            marginTop: [theme.spaces.md, null]
          }
        }, additional_button), {}, {
          type: getAdditionalButtonType()
        }))]
      }), tooltip && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, tooltip), {}, {
        textProps: {
          $styles: {
            marginTop: [theme.spaces.md]
          }
        },
        size: "tiny",
        color: isDarkMode ? 'white' : tooltip.color,
        colorTransparency: isDarkMode ? 0.7 : null
      })), image && /*#__PURE__*/_jsx(Box, {
        $styles: {
          position: 'relative',
          overflowX: 'auto'
        },
        $mt: [40, 80],
        $mx: [-20, null, null, null],
        children: /*#__PURE__*/_jsx(Box, {
          $styles: image.big ? ImageBigStyles : ImageNormalStyles,
          children: /*#__PURE__*/_jsx(LazyImageAdapter, {
            assets: {
              mobile: image.mobile,
              desktop: image.desktop
            }
          })
        })
      }), (video === null || video === void 0 ? void 0 : video.id) && /*#__PURE__*/_jsx(Box, {
        $styles: {
          position: 'relative'
        },
        $mt: [40, 80],
        children: /*#__PURE__*/_jsx(Box, {
          $styles: video.big ? VideoBigStyles : VideoNormalStyles,
          children: /*#__PURE__*/_jsx(Video, {
            id: video.id,
            thumbnail: video.thumbnail
          })
        })
      })]
    })
  });
};

export default Hero;